<template>
  <div class="container">
    <div class="slide-wrapper">
      <transition-group name="fade">
        <div
          class="slide"
          v-for="(slide, index) in data"
          :key="`key-${index}`"
          v-show="index == currentSlideNumber"
        >
          <div class="slide-image">
            <img
              loading="lazy"
              :src="slide.image ? slide.image : 'https://source.unsplash.com/600x400/?roofracks,4x4'"
              :alt="slide && slide.title ? slide.title : slide.category"
            />
          </div>
          <div class="slide-detail">
            <div class="top">
              <h3>{{ slide.category }}</h3>
              <h4 class="h4">{{ slide.title }}</h4>
              <p>{{ slide.body }}</p>

              <a
                target="_blank"
                v-if="slide.link_text && slide.link"
                :href="slide.link"
                class="btn-white-outline-blue"
                v-html="slide.link_text"
                :aria-label="slide.link_text + ' ' + slide.title"
              ></a>
            </div>
            <div class="slide-dots" role="navigation" aria-label="Page Controls">
              <a
                v-for="(slide, index) in data"
                :key="`key-${index}`"
                :class="{ active: index == currentSlideNumber }"
                @click="gotToSlide(index)"
                :aria-name="`item ${index + 1}`"
              ></a>
            </div>
          </div>
        </div>
      </transition-group>
    </div>
  </div>
</template>

<script>
export default {
  name: "cross-fade-slider",
  props: ["data"],
  data() {
    return {
      currentSlideNumber: 0,
      intervalId: null,
      delay: 4000
    };
  },
  mounted() {
    this.startAnimation();
  },
  methods: {
    gotToSlide(slideNumber) {
      this.currentSlideNumber = slideNumber;
      clearInterval(this.intervalId);
      this.startAnimation();
    },
    getNextSlide() {
      if (this.currentSlideNumber < this.data.length - 1) {
        this.currentSlideNumber += 1;
      } else {
        this.currentSlideNumber = 0;
      }
    },
    startAnimation() {
      this.intervalId = setInterval(this.getNextSlide, this.delay);
    }
  }
};
</script>

<style scoped>
  h3 {
    text-transform: uppercase;
    font-size: 0.7rem;
  }

  h4{
    font-family: "trim-medium";
    font-size: 2.5rem !important;
  }
</style>